import React from 'react';

// eslint-disable-next-line react/prop-types
const Condition = ({ when, children }) => {
  return Boolean(when) && children ? <>{children}</> : null;
};

export default Condition;
